import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const services = [
  {
    id: "pare-brise",
    num: "01",
    title: "Remplacement Pare-Brise",
    desc: "Toutes marques, vitrage homologué aux normes constructeur.",
    img: "https://images.pexels.com/photos/11950154/pexels-photo-11950154.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    id: "impact",
    num: "02",
    title: "Réparation d'Impact",
    desc: "Injection de résine haute pression en 30 minutes, sans remplacement.",
    img: "https://images.unsplash.com/photo-1756363938027-29f1dbe99e51?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "vitres",
    num: "03",
    title: "Vitres Latérales & Lunette Arrière",
    desc: "Remplacement express et nettoyage complet des débris de verre.",
    img: "https://images.unsplash.com/photo-1791824085868-b95718ac60e6?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "adas",
    num: "04",
    title: "Calibration Caméra ADAS",
    desc: "Recalibrage de précision des caméras et capteurs de sécurité.",
    img: "https://images.pexels.com/photos/8478210/pexels-photo-8478210.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative bg-[#070708] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D4AF37]">Nos prestations</p>
          <h2 className="mt-4 font-display text-4xl uppercase text-white sm:text-5xl lg:text-6xl">
            Experts du <span className="text-gold-gradient">vitrage automobile</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-zinc-400">
          Du simple impact au pare-brise complet avec caméra, nous intervenons sur tous les véhicules, à domicile ou à
          l'atelier.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={0.08 * i}>
            <a
              href="#rendez-vous"
              data-testid={`service-card-${s.id}`}
              className="group relative block overflow-hidden rounded-2xl border border-white/10 bg-[#0D0D0F] transition-colors duration-500 hover:border-[#D4AF37]/50"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="h-full w-full object-cover opacity-60 transition-all duration-700 group-hover:scale-105 group-hover:opacity-80"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent" />
                <span className="absolute right-4 top-4 font-display text-xl text-[#D4AF37]/60">{s.num}</span>
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <div className="mb-3 h-px w-8 bg-[#D4AF37] transition-all duration-500 group-hover:w-16" />
                  <h3 className="font-display text-2xl uppercase leading-tight text-white">{s.title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-zinc-400">{s.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-widest text-[#E6CA65] opacity-0 transition-all duration-500 group-hover:opacity-100">
                    Réserver <ArrowUpRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
